export const env = {
  REACT_APP_API_URL: import.meta.env.REACT_APP_API_URL,
  REACT_APP_GOOGLE_MAPS_API_KEY: import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_PUSHER_KEY: import.meta.env.REACT_APP_PUSHER_KEY,
  REACT_APP_PUSHER_CLUSTER: import.meta.env.REACT_APP_PUSHER_CLUSTER,
  REACT_APP_PUSHER_AUTH_ENDPOINT: import.meta.env.REACT_APP_PUSHER_AUTH_ENDPOINT,
  REACT_APP_LOGGER_HANDLER: import.meta.env.REACT_APP_LOGGER_HANDLER,
  REACT_APP_SENTRY_ENVIRONMENT: import.meta.env.REACT_APP_SENTRY_ENVIRONMENT,
  REACT_APP_LOGGER_LEVEL: import.meta.env.REACT_APP_LOGGER_LEVEL,
  REACT_APP_ALARM_NOTIFICATION: import.meta.env.REACT_APP_ALARM_NOTIFICATION,
  REACT_APP_COUNTRY_CODE: import.meta.env.REACT_APP_COUNTRY_CODE,
  REACT_APP_WORKSPACE_URL: import.meta.env.REACT_APP_WORKSPACE_URL,
  REACT_APP_ADMIN_API_URL: import.meta.env.REACT_APP_ADMIN_API_URL,
  REACT_APP_WORKFLOWS_API_URL: import.meta.env.REACT_APP_WORKFLOWS_API_URL,
  REACT_APP_PROTECTOR_UI_URL: import.meta.env.REACT_APP_PROTECTOR_UI_URL,
  REACT_APP_ADMIN_UI_URL: import.meta.env.REACT_APP_ADMIN_UI_URL,
  REACT_APP_WORKFLOWS_UI_URL: import.meta.env.REACT_APP_WORKFLOWS_UI_URL,
  REACT_APP_MIXPANEL_TOKEN: import.meta.env.REACT_APP_MIXPANEL_TOKEN,
  REACT_APP_ENABLE_MIXPANEL_LOGGING: import.meta.env.REACT_APP_ENABLE_MIXPANEL_LOGGING,
  REACT_APP_ADMIN_OIDC_URL: import.meta.env.REACT_APP_ADMIN_OIDC_URL,
  REACT_APP_FUSION_AUTH_URL: import.meta.env.REACT_APP_FUSION_AUTH_URL,
  REACT_APP_FUSION_AUTH_CLIENT_ID: import.meta.env.REACT_APP_FUSION_AUTH_CLIENT_ID,
  REACT_APP_HUBSPOT_PORTAL_ID: import.meta.env.REACT_APP_HUBSPOT_PORTAL_ID,
  REACT_APP_CSRF_COOKIE_NAME: import.meta.env.REACT_APP_CSRF_COOKIE_NAME,
  REACT_APP_NAME: process.env.REACT_APP_NAME,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  REACT_APP_CLARITY_PROJECT_ID: import.meta.env.REACT_APP_CLARITY_PROJECT_ID,
  LOGGING_ENABLED: import.meta.env.LOGGING_ENABLED || 'false',
  JEST_WORKER_ID: typeof process !== 'undefined' ? process.env.JEST_WORKER_ID : undefined,
  ENV_NAME: import.meta.env.ENV_NAME,
  REACT_APP_MUI_X_LICENSE_KEY: import.meta.env.REACT_APP_MUI_X_LICENSE_KEY,
  REACT_APP_TIP_TAP_APP_ID: import.meta.env.REACT_APP_TIP_TAP_APP_ID,
  REACT_APP_TIP_TAP_TOKEN: import.meta.env.REACT_APP_TIP_TAP_TOKEN,
  REACT_APP_TIP_TAP_AI_APP_ID: import.meta.env.REACT_APP_TIP_TAP_AI_APP_ID,
  REACT_APP_TIP_TAP_AI_TOKEN: import.meta.env.REACT_APP_TIP_TAP_AI_TOKEN,
  REACT_APP_TIP_TAP_CONVERT_APP_ID: import.meta.env.REACT_APP_TIP_TAP_CONVERT_APP_ID,
  REACT_APP_PUBLIC_FORM_URL: import.meta.env.REACT_APP_PUBLIC_FORM_URL,
  REACT_APP_SENTRY_DSN: import.meta.env.REACT_APP_SENTRY_DSN,
  REACT_APP_SENTRY_TRACES_SAMPLE_RATE: import.meta.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
  REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE: import.meta.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: import.meta.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS: import.meta.env.REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS,
  REACT_APP_KNOCK_PUBLIC_API_KEY: import.meta.env.REACT_APP_KNOCK_PUBLIC_API_KEY,
  // ENG-10919: set to 'true' by apps/prototypes/.env.development so workspace
  // code can opt into prototype-specific code paths (e.g. the Config gate
  // bypass). Unset in production.
  REACT_APP_IS_PROTOTYPE: import.meta.env.REACT_APP_IS_PROTOTYPE,
};
